import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import React from 'react';
import { convert_dd_mm_yy_to_milliseconds } from '../../../Pages/HomePage/components/BacklogTable/utils/util';

const ControlledTableDatePicker = ({ excel_row, key_name, on_change_handler }) => {
  return (
    <DatePicker
      format='DD/MM/YYYY' disablePast={!excel_row[key_name] ? true : false} readOnly={excel_row[key_name] ? true : false} defaultValue={excel_row[key_name] && dayjs((() => {
        if (excel_row[key_name]) {
          // console.log({ date: excel_row[key_name] });
          return convert_dd_mm_yy_to_milliseconds(excel_row[key_name]);
        }
      })())}
      onChange={(e) => {
        console.log("changed", e);
        on_change_handler(e, excel_row, key_name);
      }}
    />
  );
};

export default ControlledTableDatePicker;